import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=48135e35&scoped=true"
import script from "./AuthLayout.vue?vue&type=script&lang=js"
export * from "./AuthLayout.vue?vue&type=script&lang=js"
import style0 from "./AuthLayout.vue?vue&type=style&index=0&id=48135e35&prod&lang=scss&scoped=true"
import style1 from "./AuthLayout.vue?vue&type=style&index=1&id=48135e35&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48135e35",
  null
  
)

export default component.exports